import React, { useState } from 'react';
import {
  Stack,
  Typography,
  Link,
  Stepper,
  Step,
  StepLabel,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { LOGIN } from '../../routes/CONSTANTS';
import PageTitle from '../../common/components/PageTitle';
import RequestResetForm from './RequestResetForm';
import SetNewPasswordForm from './SetNewPasswordForm';
import useMediaQuery from '@mui/material/useMediaQuery';

const steps = ['Request Code', 'Set New Password', 'Complete'];

export function PasswordReset() {
  const [activeStep, setActiveStep] = useState(0);
  const [username, setUsername] = useState('');

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));

  const handleSetUsername = (email) => {
    setUsername(email);
  };

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  return (
    <>
      <PageTitle title='Reset Password' />
      <Stack
        direction='column'
        alignItems='center'
        justifyContent='center'
        spacing={2}
      >
        <Stepper
          activeStep={activeStep}
          sx={{ width: '60%' }}
          {...(isSmallScreen
            ? { orientation: 'vertical' }
            : { orientation: 'horizontal' })}
        >
          {steps.map((label) => {
            return (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        {activeStep === 0 ? (
          <>
            <Typography sx={{ textAlign: 'left' }}>
              Please enter the email address for your account. If an account
              exists with that email address, an email with a reset verification
              code will be sent shortly.
            </Typography>
            <RequestResetForm
              setUsername={handleSetUsername}
              successAction={handleNext}
            />
          </>
        ) : activeStep === 1 ? (
          <>
            <Typography sx={{ textAlign: 'left' }}>
              Please check your email for a verification code. Enter the
              verification code along with a new password below to set a new
              password for your account.
            </Typography>
            <SetNewPasswordForm
              username={username}
              successAction={handleNext}
            />
          </>
        ) : activeStep === 2 ? (
          <>
            <Typography color='success.main'>
              New password succesfully set.
            </Typography>
            <Typography>
              Please{' '}
              <Link to={LOGIN} component={RouterLink}>
                login here
              </Link>{' '}
              using your new password to continue.
            </Typography>
          </>
        ) : (
          <>
            <Typography>
              Something didn't work right, please reset the page and try again.
            </Typography>
          </>
        )}
      </Stack>
    </>
  );
}
